module.exports = __webpack_public_path__ + "assets/appdynamics.eefa09a2.svg";